import React, { useState, useEffect, useContext } from "react";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MessageIcon from '@material-ui/icons/Message';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { CardActionArea } from '@mui/material';
import placeholder from '../../../assets/Subject-cover-placeholder.png';
import "./SubjectCard.scss";

function SubjectCard({ subject, handleEdit, handleView, handleDelete }) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function formatDate(data) {
        let d = new Date(data);
        return ((d.getDate() < 10 ? '0' + d.getDate() : d.getDate())  + '/' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1))  + '/' + d.getFullYear())
    }


    return (
        <div className="subject-card">
            <Card style={{ maxWidth: 345 }}>

                <div class="Card-img-container">
                    {subject.cover == null ?
                        <img src={placeholder}  /> :
                        <img src={subject.cover.photo}  />
                    }
                    {subject.admin && 
                    <IconButton aria-label="settings" className={"Card-icon-btn"} fontSize="large" style={{ color: 'white' }}
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>}
                </div>
                <CardActionArea onClick={handleView}>
                    <CardContent >
                        <div className="Card-content-title">
                            {subject.name}
                        </div>
                        <div className="Card-content-container">
                            <div className="Card-content-text">
                                <span >
                                    Atualizada em {formatDate(subject.lastUpdate)}
                                </span>
                            </div>
                        </div>
                    </CardContent>
                </CardActionArea>

            </Card>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={handleEdit}>Editar</MenuItem>
                <MenuItem onClick={() =>{handleClose();handleDelete();}}>Excluir</MenuItem>
            </Menu>
        </div>

    );
}

export default SubjectCard;
